import Tab from "./tab";
import "./tabular.scss";

export * from "./tabular";
export { Tab };



// WEBPACK FOOTER //
// ./src/gui/tabular/index.ts